
import { motion } from "framer-motion";
import HeroIndex from "../components/home/HeroIndex";
import SkincareSpecial from "../components/home/SkincareSpecial";
import AboutUs from "../components/home/AboutUs";
import DiscoverProducts from "../components/home/DiscoverProducts";
import SkinQuiz from "../components/home/SkinQuiz";
import PromoBanner from "../components/home/PromoBanner";
import LatestArticles from "../components/home/LatestArticles";
import Testimonials from "../components/home/Testimonials";
import Swal from "sweetalert2";

const fadeIn = {
  initial: { opacity: 0, y: 20 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 1 },
};

export default function Home() {
  const handleSubscribe = (e) => {
  e.preventDefault();
  Swal.fire({
    icon: "success",
    title: "You're in! 🎉",
    text: "Thanks for subscribing to SuprSkin. Get ready to glow ✨",
    confirmButtonColor: "#809080",
  });
};

  return (
    <div>
      <HeroIndex />
      <SkincareSpecial />
      <AboutUs />
      <DiscoverProducts />
      <SkinQuiz />
      <PromoBanner />
      <LatestArticles />
      <Testimonials />

      {/* Newsletter Section */}
      <div className="bg-[#fef8f5] py-20 px-4">
        <div className="max-w-7xl mx-auto text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <h2 className="text-3xl font-serif font-bold mb-4 text-[#7a6e5f]">
              Let’s Glow Together ✨
            </h2>
            <p className="mb-8 text-[#7a6e5f] opacity-90 max-w-md mx-auto">
              Get skincare tips, promos, and product drops delivered right to your inbox.
            </p>
            <form
              className="max-w-md mx-auto flex flex-col sm:flex-row gap-4"
              onSubmit={handleSubscribe}
            >
              <input
                type="email"
                placeholder="Enter your email"
                required
                className="flex-1 px-4 py-3 rounded-md border border-[#d6a89e] focus:ring-2 focus:ring-[#809080] outline-none text-[#7a6e5f]"
              />
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                type="submit"
                className="bg-[#809080] text-white px-8 py-3 rounded-md hover:bg-[#6f7c6f] transition-colors"
              >
                Subscribe
              </motion.button>
            </form>
          </motion.div>
        </div>
      </div>
    </div>
  );
}
